export const ADD_NOTIFICATION = 'ADD_UN_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_UN_NOTIFICATION';
export const DISMISS_NOTIFICATIONS = 'DISMISS_NOTIFICATIONS';
